<mat-dialog-content class="updateDialog">
    <h2 mat-dialog-title>Update Records</h2>
    <div fxHide [fxShow]="showProgress">
        <mat-progress-bar [mode]="progressMode" mode="determinate" value="{{completeProgress}}"></mat-progress-bar>
        Updating {{currentProcessIndex + 1}} of {{totalProcessCount}}
        <br/> {{processingRecord}}
    </div>
</mat-dialog-content>
